import {AdicionalDeProdutoMultiplaEscolha} from './AdicionalDeProdutoMultiplaEscolha';
import {ConfigComponenteKit} from '../kit/ConfigComponenteKit';

export class AdicionalDeProdutoComponenteKit extends AdicionalDeProdutoMultiplaEscolha {
  configComponenteKit = new ConfigComponenteKit();

  constructor(nome: string = '', opcoes: any[] = []) {
    super(nome, true, opcoes, 0, null, true);
    this.tipo = 'componente-kit';
    this.classe = 'componente-kit-produto';
    this.multiplicaQuantidadeProduto = true;
  }

  clone(): AdicionalDeProdutoComponenteKit {
    const novo = new AdicionalDeProdutoComponenteKit(this.nome, this.opcoesDisponiveis.map(o => {
      const opcao = o.clone();
      opcao.qtdeMinima = o.qtdeMinima; opcao.qtdeMaxima = o.qtdeMaxima;
      opcao.oculta = o.oculta;
      if (o.insumo?.id) Object.assign(opcao, {insumoId: o.insumo.id, insumo: o.insumo});
      return opcao;
    }));
    novo.configComponenteKit = Object.assign(new ConfigComponenteKit(), JSON.parse(JSON.stringify(this.configComponenteKit)));
    novo.configComponenteKit.quantidades.forEach(q => { q.id = null; });
    return novo;
  }

  obtenhaDescricao(): string { return 'Complete a quantidade deste grupo do kit.'; }
}
